"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    miao: '庙',
    wang: '旺',
    de: '得',
    li: '利',
    ping: '平',
    bu: '不',
    xian: '陷',
};
